import React from 'react';
interface LeadParagraphProps {
  children: React.ReactNode;
}
export function LeadParagraph({
  children
}: LeadParagraphProps) {
  return <p className="text-fluid-xl md:text-[clamp(1.555rem,2.5vw,2.074rem)] text-[#111111] animate-fadeIn font-semibold leading-snug" data-id="element-127">
      {children}
    </p>;
}